import { createContext } from 'react'
import { RxState } from 'rxdb'

import { ApplicationNetworkState } from '@/system/rxdb/replication.ts'

export const NetworkStateContext =
  createContext<RxState<ApplicationNetworkState> | null>(null)
